export default class ShipyardCommand {
  name: string
  country: string
  yearFounded: number
  websiteUrl: string
  youtubeChannelUrl: string

  constructor() { 
    this.name = ''
    this.country = ''
    this.yearFounded = 0
    this.websiteUrl = ''
    this.youtubeChannelUrl = ''
  }
}
